import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllCertificateUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllCertificate/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllCertificateUser = data;

    // console.log('Сервер вернул данные по Certificate ---- ',response.data);


    return AllCertificateUser;
};


const setActiveCertificate = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setCertificateActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCertificateUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Certificate  - ',response);


    return AllCertificateUser;
};



const setDeletedCertificate = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setCertificateDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCertificateUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Certificate  - ',response);


    return AllCertificateUser;
};




const setUpdateCertificate = async (dataCertificateUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setCertificateUpdate/'),{
        dataCertificateUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllCertificateUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Certificate  - ',dataCertificateUpdate,response);


    return AllCertificateUser;
};


const setSaveNewCertificate = async (dataCertificateUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewCertificate/'),{
        dataCertificateUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllCertificateUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Certificate  - ',response, dataCertificateUpdate);


    return AllCertificateUser;
};

Mock.onGet('/api/reference/getAllCertificate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllCertificateUser = await getAllCertificateUser();
    // console.log('С сервера пришло - ', AllCertificateUser);

    // if (!AllCertificateUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllCertificateUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCertificateUser,
    ]


})


Mock.onPost('/api/reference/setActiveCertificate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllCertificateUser = await setActiveCertificate(id,val);

    // if (!AllCertificateUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllCertificateUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCertificateUser,
    ]


})

Mock.onPost('/api/reference/setDeletedCertificate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllCertificateUser = await setDeletedCertificate(id,val);

    // if (!AllCertificateUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllCertificateUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllCertificateUser,
    ]


})


Mock.onPost('/api/reference/setUpdateCertificate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataCertificateUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Certificate = await setUpdateCertificate(dataCertificateUpdate);

    // console.log('Серовер вернул данные ',AllCertificateUser);

    // if (!Certificate) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Certificate) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Certificate,
    ]


})


Mock.onPost('/api/reference/setSaveNewCertificate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataCertificateUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Certificate = await setSaveNewCertificate(dataCertificateUpdate);

    // console.log('Серовер вернул данные ',AllCertificateUser);

    // if (!Certificate) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Certificate) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Certificate,
    ]
})